module.exports = __webpack_public_path__ + "static/img/Gini-product-1.780e405.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/Gini-product-1.png
// module id = 4Q73
// module chunks = 1